(function () {
  if (window.SlimfairTrustshopReviewMedia) return;
  window.SlimfairTrustshopReviewMedia = true;

  var MAX_VISIBLE = 5;
  var VISIBLE_BEFORE_OVERFLOW = 4;
  var modal = null;
  var modalState = { media: [], index: 0 };

  function upgradeImageUrl(url) {
    if (!url) return url;
    return url
      .replace(/\/small\//g, "/large/")
      .replace(/\/thumb\//g, "/large/")
      .replace(/_small\./g, "_large.")
      .replace(/_thumb\./g, "_large.")
      .replace(/([?&])w=\d+/g, "$1w=1200");
  }

  function isVideoItem(item) {
    return (
      item.querySelector("svg") !== null ||
      item.querySelector('[class*="video"]') !== null ||
      item.classList.contains("trustshop-media-video")
    );
  }

  function getThumbUrl(item) {
    var img =
      item.matches && item.matches("img") ? item : item.querySelector("img");
    if (!img) return "";

    return img.currentSrc || img.src || img.getAttribute("data-src") || "";
  }

  function isLikelyReviewPhoto(img) {
    var src = img.currentSrc || img.src || img.getAttribute("data-src") || "";
    var renderedWidth = img.clientWidth || img.width || img.naturalWidth || 0;
    var renderedHeight =
      img.clientHeight || img.height || img.naturalHeight || 0;

    if (!src || /\.svg($|\?)/i.test(src)) return false;
    if (renderedWidth && renderedWidth < 36) return false;
    if (renderedHeight && renderedHeight < 36) return false;

    return true;
  }

  function isReviewImageCandidate(item) {
    if (
      item.matches &&
      item.matches(
        '.trustshop-review-media--item, .trustshop-media--item, .trustshop-media, [class*="review-media--item"]',
      )
    ) {
      return true;
    }

    var img =
      item.matches && item.matches("img") ? item : item.querySelector("img");
    if (!img) return isVideoItem(item);

    var label = [
      item.className,
      img.className,
      item.id,
      img.id,
      item.closest("[class]") ? item.closest("[class]").className : "",
    ]
      .join(" ")
      .toLowerCase();

    if (/(author|avatar|avt|badge|verified|rating|star|logo|icon)/.test(label))
      return false;

    return (
      /(media|photo|image|picture|video|attachment)/.test(label) ||
      isLikelyReviewPhoto(img)
    );
  }

  function getMediaWrap(container) {
    var candidates = container.querySelectorAll(
      [
        ".trustshop-review--media",
        ".trustshop-review-media-focus--wrap",
        '[class*="review-media"]',
        '[class*="review-photo"]',
        '[class*="review-image"]',
        '[class*="review-picture"]',
        '[class*="attachment"]',
      ].join(", "),
    );

    for (var i = 0; i < candidates.length; i++) {
      if (
        !candidates[i].classList.contains("sf-review-media") &&
        !candidates[i].closest(".sf-review-media")
      ) {
        return candidates[i];
      }
    }

    return null;
  }

  function getMediaItems(container) {
    var mediaWrap = getMediaWrap(container);
    var scope = mediaWrap || container;
    var selectors = [
      ".trustshop-review-media--item",
      ".trustshop-media--item",
      '[class*="review-media"]',
      '[class*="review-photo"]',
      '[class*="review-image"]',
      '[class*="review-picture"]',
      '[class*="media-item"]',
      '[class*="attachment"]',
      "img",
    ].join(", ");

    return Array.prototype.filter.call(
      scope.querySelectorAll(selectors),
      isReviewImageCandidate,
    );
  }

  function collectMedia(container) {
    var seen = {};
    var items = getMediaItems(container);

    return Array.prototype.map
      .call(items, function (item) {
        var thumbUrl = getThumbUrl(item);
        return {
          thumbUrl: thumbUrl,
          fullUrl: upgradeImageUrl(thumbUrl),
          isVideo: isVideoItem(item),
          source: item,
        };
      })
      .filter(function (media) {
        var key =
          media.thumbUrl ||
          (media.isVideo && media.source ? media.source.outerHTML : "");
        if (!key || seen[key]) return false;
        seen[key] = true;
        return media.isVideo || media.thumbUrl;
      });
  }

  function collectRootFallbackMedia(root) {
    var mediaList = collectMedia(root);

    return mediaList.filter(function (media) {
      if (!media.source) return false;
      return !media.source.closest(
        '.trustshop-review-item-type--grid, [id*="trustshop-review-id--"]',
      );
    });
  }

  function createThumb(media, index, mediaList) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "sf-review-media__thumb";
    button.setAttribute("aria-label", "View review image " + (index + 1));

    if (media.thumbUrl) {
      var image = document.createElement("img");
      image.src = media.thumbUrl;
      image.alt = "";
      image.loading = "lazy";
      image.decoding = "async";
      button.appendChild(image);
    }

    if (media.isVideo) {
      button.classList.add("sf-review-media__thumb--video");
      button.setAttribute("aria-label", "Play review video " + (index + 1));
    }

    button.addEventListener("click", function () {
      if (media.isVideo && media.source) {
        media.source.click();
        return;
      }
      openModal(mediaList, index);
    });

    return button;
  }

  function createOverflowButton(count, startIndex, mediaList) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "sf-review-media__thumb sf-review-media__thumb--more";
    button.setAttribute("aria-label", "View " + count + " more review images");

    var label = document.createElement("span");
    label.className = "sf-review-media__more-count";
    label.textContent = "+" + count;
    button.appendChild(label);

    button.addEventListener("click", function () {
      var first = mediaList[startIndex];
      if (first && first.isVideo && first.source) {
        first.source.click();
        return;
      }
      openModal(mediaList, startIndex);
    });

    return button;
  }

  function getReviewDisplayContainer(container) {
    return (
      container.querySelector(".trustshop-review-item-grid--content") ||
      container.closest(".trustshop-review-item-grid--content") ||
      container.closest(".trustshop-review-item-type--grid") ||
      container.closest('[id*="trustshop-review-id--"]') ||
      container
    );
  }

  function insertMediaGrid(container, wrap) {
    var existing = container.querySelector(".sf-review-media");
    if (existing) existing.remove();

    var content = container.querySelector(".trustshop-review--content");
    if (content && content.parentNode === container) {
      content.insertAdjacentElement("afterend", wrap);
      return;
    }

    container.appendChild(wrap);
  }

  function buildThumbnailGrid(container, mediaList, sourceContainer) {
    var total = mediaList.length;
    if (!total) return;

    var wrap = document.createElement("div");
    wrap.className = "sf-review-media";

    var visibleCount = total <= MAX_VISIBLE ? total : VISIBLE_BEFORE_OVERFLOW;
    var overflowCount =
      total > MAX_VISIBLE ? total - VISIBLE_BEFORE_OVERFLOW : 0;

    for (var i = 0; i < visibleCount; i++) {
      wrap.appendChild(createThumb(mediaList[i], i, mediaList));
    }

    if (overflowCount > 0) {
      wrap.appendChild(
        createOverflowButton(overflowCount, VISIBLE_BEFORE_OVERFLOW, mediaList),
      );
    }

    var sourceWrap = getMediaWrap(sourceContainer || container);

    if (sourceWrap) {
      sourceWrap.classList.add("sf-review-media__source--hidden");
    }

    insertMediaGrid(container, wrap);

    container.classList.add("sf-review-media--ready");
  }

  function findMediaContainers(root) {
    var reviewItems = root.querySelectorAll(
      '.trustshop-review-item-type--grid, [id*="trustshop-review-id--"], .trustshop-review-item-grid--content',
    );

    if (reviewItems.length) return reviewItems;

    return root.querySelectorAll(
      ".trustshop-review-media--container, .trustshop-review-media-focus--container",
    );
  }

  function collectMediaFromReview(reviewItem) {
    if (
      reviewItem.matches(
        ".trustshop-review-media--container, .trustshop-review-media-focus--container",
      )
    ) {
      return { container: reviewItem, mediaList: collectMedia(reviewItem) };
    }

    var mediaWrap = getMediaWrap(reviewItem);

    if (!mediaWrap && !getMediaItems(reviewItem).length) return null;

    var wrapper =
      mediaWrap.closest(
        ".trustshop-review-media--container, .trustshop-review-media-focus--container",
      ) || reviewItem;

    return { container: wrapper, mediaList: collectMedia(wrapper) };
  }

  function processMediaContainer(container, fallbackMediaList) {
    var displayContainer = getReviewDisplayContainer(container);
    if (displayContainer.classList.contains("sf-review-media--ready")) return;

    var result = collectMediaFromReview(container);
    if (!result || !result.mediaList.length) {
      if (fallbackMediaList && fallbackMediaList.length) {
        buildThumbnailGrid(displayContainer, fallbackMediaList, container);
        return;
      }

      return;
    }

    buildThumbnailGrid(displayContainer, result.mediaList, result.container);
  }

  function processReviewRoot(root) {
    var containers = findMediaContainers(root);
    var fallbackMediaList = collectRootFallbackMedia(root);

    Array.prototype.forEach.call(containers, function (container) {
      processMediaContainer(container, fallbackMediaList);
    });
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement("div");
    modal.className = "sf-review-media-modal";
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML =
      '<button type="button" class="sf-review-media-modal__backdrop" data-sf-review-media-close aria-label="Close gallery"></button>' +
      '<div class="sf-review-media-modal__dialog" role="dialog" aria-modal="true" aria-label="Review images">' +
      '<button type="button" class="sf-review-media-modal__close" data-sf-review-media-close aria-label="Close gallery">' +
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z"/></svg>' +
      "</button>" +
      '<button type="button" class="sf-review-media-modal__nav sf-review-media-modal__nav--prev" data-sf-review-media-prev aria-label="Previous image"></button>' +
      '<div class="sf-review-media-modal__stage" data-sf-review-media-stage></div>' +
      '<button type="button" class="sf-review-media-modal__nav sf-review-media-modal__nav--next" data-sf-review-media-next aria-label="Next image"></button>' +
      '<p class="sf-review-media-modal__counter" data-sf-review-media-counter></p>' +
      "</div>";

    document.body.appendChild(modal);

    modal.addEventListener("click", function (event) {
      if (event.target.closest("[data-sf-review-media-close]")) {
        closeModal();
      }
    });

    modal
      .querySelector("[data-sf-review-media-prev]")
      .addEventListener("click", function () {
        stepModal(-1);
      });

    modal
      .querySelector("[data-sf-review-media-next]")
      .addEventListener("click", function () {
        stepModal(1);
      });

    document.addEventListener("keydown", function (event) {
      if (modal.hidden) return;

      if (event.key === "Escape") {
        closeModal();
      } else if (event.key === "ArrowLeft") {
        stepModal(-1);
      } else if (event.key === "ArrowRight") {
        stepModal(1);
      }
    });

    return modal;
  }

  function renderModalSlide() {
    var stage = modal.querySelector("[data-sf-review-media-stage]");
    var counter = modal.querySelector("[data-sf-review-media-counter]");
    var prev = modal.querySelector("[data-sf-review-media-prev]");
    var next = modal.querySelector("[data-sf-review-media-next]");
    var media = modalState.media[modalState.index];

    stage.innerHTML = "";

    if (!media) return;

    if (media.isVideo && media.source) {
      closeModal();
      media.source.click();
      return;
    }

    var image = document.createElement("img");
    image.src = media.fullUrl || media.thumbUrl;
    image.alt = "Review image " + (modalState.index + 1);
    image.decoding = "async";
    stage.appendChild(image);

    counter.textContent =
      modalState.index + 1 + " / " + modalState.media.length;
    prev.disabled = modalState.index <= 0;
    next.disabled = modalState.index >= modalState.media.length - 1;
  }

  function getImageIndex(mediaList, startIndex) {
    var imageIndex = 0;
    var hasImage = false;

    for (var i = 0; i < mediaList.length; i++) {
      if (mediaList[i].isVideo) continue;
      hasImage = true;
      if (i >= startIndex) return imageIndex;
      imageIndex++;
    }

    return hasImage ? Math.max(0, imageIndex - 1) : 0;
  }

  function openModal(mediaList, startIndex) {
    var imagesOnly = mediaList.filter(function (item) {
      return !item.isVideo;
    });

    if (!imagesOnly.length) {
      var video = mediaList[startIndex];
      if (video && video.source) video.source.click();
      return;
    }

    var target = mediaList[startIndex];
    if (target && target.isVideo && target.source) {
      target.source.click();
      return;
    }

    modalState.media = imagesOnly;
    modalState.index = getImageIndex(mediaList, startIndex);

    ensureModal();
    renderModalSlide();
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("sf-review-media-open");
    modal.querySelector(".sf-review-media-modal__close").focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.querySelector("[data-sf-review-media-stage]").innerHTML = "";
    document.documentElement.classList.remove("sf-review-media-open");
  }

  function stepModal(direction) {
    var nextIndex = modalState.index + direction;
    if (nextIndex < 0 || nextIndex >= modalState.media.length) return;
    modalState.index = nextIndex;
    renderModalSlide();
  }

  var boundRoots = typeof WeakSet !== "undefined" ? new WeakSet() : null;
  var boundRootIds = {};

  function isRootBound(root) {
    if (boundRoots) return boundRoots.has(root);
    var key = root.id || root.getAttribute("data-product-id") || root.className;
    return !!boundRootIds[key];
  }

  function markRootBound(root) {
    if (boundRoots) {
      boundRoots.add(root);
      return;
    }
    var key = root.id || root.getAttribute("data-product-id") || root.className;
    boundRootIds[key] = true;
  }

  function bindReviewRoot(root) {
    if (!root || isRootBound(root)) return;

    markRootBound(root);

    var run = function () {
      processReviewRoot(root);
    };

    run();

    var observer = new MutationObserver(run);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "data-src"],
    });

    var attempts = 0;
    var retryTimer = window.setInterval(function () {
      run();
      attempts += 1;
      if (attempts >= 40) window.clearInterval(retryTimer);
    }, 500);
  }

  function findReviewRoots() {
    return document.querySelectorAll("#trustshop-review, .sf-trustshop-pdp");
  }

  function init() {
    var roots = findReviewRoots();
    Array.prototype.forEach.call(roots, bindReviewRoot);

    if (typeof MutationObserver === "undefined") return;

    var pageObserver = new MutationObserver(function () {
      Array.prototype.forEach.call(findReviewRoots(), bindReviewRoot);
    });

    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
